import {i18n} from '@online-offer/i18n';
import {Box, Heading, Link, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {isURLDangerous} from 'shared/web';

import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {CarPassValidity} from './CarPassValidity';

export function CarPassPrint() {
  const {carPassDocumentPublicUrl, carPassDocumentDownloadedAt} = useGetOnlineOfferData();

  // Only shown when a Car-Pass document exists; bail on unsafe URLs (the Link below also
  // guards via isURLDangerous, but not rendering is cleaner than triggering its error path).
  if (isNilOrEmpty(carPassDocumentPublicUrl) || isURLDangerous(carPassDocumentPublicUrl)) {
    return null;
  }

  return (
    <Box paddingHorizontal={10} paddingVertical={5}>
      <CardOo paddingVertical={6} paddingHorizontal={6} backgroundColor="semantic.bg.subtle">
        <VStack spacing={2}>
          <Heading size={3}>{i18n.t('carPass.heading')}</Heading>
          <CarPassValidity downloadedAt={carPassDocumentDownloadedAt} />
          {/* Print/PDF: clickable URL so the report is reachable from the printed page. */}
          <Link
            href={carPassDocumentPublicUrl}
            title={carPassDocumentPublicUrl}
            size="small"
            target="_blank"
            rel="noopener noreferrer"
            overflowWrap="anywhere"
            data-testid="carPassPrintUrl"
          />
        </VStack>
      </CardOo>
    </Box>
  );
}
